<template>
  <section class="section about">
    <div class="about-wrapper">
      <div class="about-box">
        <div class="about-content" v-html="aboutContent"></div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'

const aboutContent = ref('')
const { locale } = useI18n()

watchEffect(async () => {
  const lang = locale.value
  try {
    const fileUrl = `/about-content/${lang}.html`
    aboutContent.value = await fetch(fileUrl).then(res => res.text())
  } catch (error) {
    aboutContent.value = `<p>İçerik yüklenemedi.</p>`
    console.error('HTML içeriği yüklenemedi:', error)
  }
})
</script>

<style scoped>
.about-wrapper {
  display: flex;
  justify-content: center;
  padding: 100px 20px 60px; /* Header ile boşluk */
  background: #f8f8f847;
  min-height: 100vh;
}

.about-box {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  max-width: 900px;
  width: 100%;
  box-sizing: border-box;
}

.about-content :deep(h1),
.about-content :deep(h2) {
  text-align: center;
  color: #000000;
  margin-top: 40px;
  margin-bottom: 20px;
}

.about-content :deep(h1) {
  font-size: 3em;
}

.about-content :deep(h2) {
  font-size: 2em;
}



.about-content h1 {
  font-size: 2em;
}

.about-content h2 {
  font-size: 1.5em;
}

.about-content ul {
  list-style: disc;
  padding-left: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.about-content li {
  margin-bottom: 8px;
}
@media (max-width: 768px) {
  .about-wrapper {
    padding: 60px 15px 40px;
  }

  .about-box {
    padding: 25px 20px;
  }

  .about-content :deep(h1) {
    font-size: 2rem;
  }

  .about-content :deep(h2) {
    font-size: 1.4rem;
  }

  .about-content ul {
    padding-left: 20px;
  }
}
</style>
